/**
* Returns the first ancestor element of elem which satisfies the given predicate or null if no such ancestor element exists.
* @param elem
* @param predicate
* @returns {}
*/
export default function getFirstAncestor(elem, predicate) {
    if (!elem.parentElement)
        return null;
    if (predicate(elem.parentElement))
        return elem.parentElement;
    return getFirstAncestor(elem.parentElement, predicate);
}
